<template>
  <v-dialog v-if="show" v-model="show" persistent width="85%">
    <v-card color="cardbg">
      <v-card-title class="headline font-weight-bold pb-0">
        {{ $t("appointments.details.doneResultDialog.title") }}
      </v-card-title>
      <v-card-text class="body-1 font-weight-bold pt-2 card-text-color">
        <div v-if="showKoResult">
          {{ $t("appointments.details.doneResultDialog.textKo") }}
        </div>
        <div v-if="showParzialeResult">
          {{ $t("appointments.details.doneResultDialog.textParziale") }}
        </div>
      </v-card-text>
      <v-card-text>
        <v-row
          class="no-gutters justify-space-between bg-white mb-2 align-center"
        >
          <!-- list of appointments with KO or PARZIALE result -->
          <v-col xs="12" sm="12" md="12" lg="12" xl="12">
            <v-list two-line class="py-0">
              <v-list-item-group>
                <template v-for="(app, index) in appointmentResultsToUse">
                  <v-list-item :key="app.appointmentId" inactive>
                    <template>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold"
                          ><span
                            >{{
                              $t("appointments.details.doneResultDialog.app")
                            }}&nbsp;{{ index + 1 }}</span
                          ><span
                            >&#58;&nbsp;{{
                              app.codiceFiscale
                            }}&nbsp;&#45;&nbsp;{{
                              app.iupCode
                            }}&nbsp;&#45;&nbsp;{{
                              formattedDate(app.appointmentDeliveryDate)
                            }}</span
                          ></v-list-item-title
                        >
                        <v-list-item-subtitle
                          class="font-italic font-weight-medium black--text"
                          ><span>{{
                            formattedResult(
                              app.massimaleCheckResult,
                              app.coperturaCheckResult
                            )
                          }}</span></v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                  <v-divider
                    v-if="index < appointmentResultsToUse.length - 1"
                    :key="index"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4">
        <v-row no-gutters justify="end">
          <v-btn
            color="primary"
            class="font-weight-bold"
            @click="confirm"
            rounded
            depressed
            >{{ $t("forwardButton") }}</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appointmentsOutOfRangeResults: {
      type: Array,
      required: true,
      default: () => []
    },
    appointmentsOkResults: {
      type: Array,
      required: true,
      default: () => []
    },
    appointmentsParzialeResults: {
      type: Array,
      required: true,
      default: () => []
    },
    appointmentsKoResults: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        if (this.appointmentsKoResults.length > 0) {
          this.showKoResult = true;
          this.appointmentResultsToUse = this.appointmentsKoResults;
          if (this.appointmentsParzialeResults.length > 0) {
            this.showParzialeResult = false;
            this.needToShowParzialeResults = true;
          }
        } else {
          this.showKoResult = false;
          this.appointmentResultsToUse = this.appointmentsParzialeResults;
          this.showParzialeResult = true;
        }
      }
    }
  },
  data() {
    return {
      dateFormat: "DD/MM/YYYY",
      appointmentResultsToUse: [],
      showKoResult: false,
      showParzialeResult: false,
      needToShowParzialeResults: false
    };
  },
  created() {},
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    },
    existAppointmentsWithOkResults() {
      return this.appointmentsOkResults.length > 0;
    }
  },
  methods: {
    formattedDate(deliveryDate) {
      return deliveryDate && dayjs(deliveryDate).isValid()
        ? dayjs(deliveryDate).format(this.dateFormat)
        : null;
    },
    formattedResult(massimale, copertura) {
      // no copertura e massimale esaurito
      if (!copertura && massimale && massimale === "ESAURITO") {
        let c = this.$t(
          `appointments.details.doneResultDialog.coperturaKoResult`
        );
        let m = this.$t(
          `appointments.details.doneResultDialog.massimaleKoResult`
        );
        return `${c} e ${m}`;
      }
      // no copertura e massimale parziale
      if (!copertura && massimale && massimale === "PARZIALE") {
        let c = this.$t(
          `appointments.details.doneResultDialog.coperturaKoResult`
        );
        let m = this.$t(
          `appointments.details.doneResultDialog.massimaleParzialeResult`
        );
        return `${c} e ${m}`;
      }
      // no copertura e massimale ok
      if (!copertura && massimale && massimale === "OK") {
        return this.$t(
          `appointments.details.doneResultDialog.coperturaKoResult`
        );
      }
      // no copertura
      if (!copertura) {
        return this.$t(
          `appointments.details.doneResultDialog.coperturaKoResult`
        );
      }
      // si copertura e massimale esaurito
      if (copertura && massimale && massimale === "ESAURITO") {
        return this.$t(
          `appointments.details.doneResultDialog.massimaleKoResult`
        );
      }
      // si copertura e massimale parziale
      if (copertura && massimale && massimale === "PARZIALE") {
        return this.$t(
          `appointments.details.doneResultDialog.massimaleParzialeResult`
        );
      }
      // massimale esaurito
      if (massimale && massimale === "ESAURITO") {
        return this.$t(
          `appointments.details.doneResultDialog.massimaleKoResult`
        );
      }
      // massimale parziale
      if (massimale && massimale === "PARZIALE") {
        return this.$t(
          `appointments.details.doneResultDialog.massimaleParzialeResult`
        );
      }
      return null;
    },
    async confirm() {
      if (this.showKoResult) {
        this.setAppointmentsToAdministrativeCheckRequired(
          this.appointmentsKoResults
        );
        if (this.needToShowParzialeResults) {
          this.showKoResult = false;
          this.appointmentResultsToUse = this.appointmentsParzialeResults;
          this.showParzialeResult = true;
        } else {
          if (this.existAppointmentsWithOkResults) {
            this.addAcceptedAppointments(this.appointmentsOkResults, true);
            this.closeDialog();
          } else {
            this.closeDialogAndReloadPage();
          }
        }
      } else {
        let needToReloadPage = true;
        if (this.existAppointmentsWithOkResults) {
          // set to false, because the page will be reloaded after accepted OK appointments
          needToReloadPage = false;
        }
        await this.addAcceptedAppointments(
          this.appointmentsParzialeResults,
          needToReloadPage
        );
        if (this.existAppointmentsWithOkResults) {
          await this.addAcceptedAppointments(this.appointmentsOkResults, true);
          this.closeDialog();
        } else {
          this.closeDialogAndReloadPage();
        }
      }
    },
    async setAppointmentsToAdministrativeCheckRequired(appointments) {
      for (let app of appointments) {
        let params = {
          appId: app.appointmentId,
          appDeliveryDate: app.appointmentDeliveryDate
        };
        await this.$store.dispatch(
          "appointments/callSetAppointmentToAdministrativeCheckRequired",
          params
        );
      }
    },
    async addAcceptedAppointments(appointments, reloadPage) {
      let payload = { apps: appointments, needToReloadPage: reloadPage };
      this.$emit("addacceptedappointment", payload);
    },
    closeDialog() {
      this.show = false;
    },
    closeDialogAndReloadPage() {
      this.$emit("closeandreloadpage");
    }
  }
};
</script>

<style scoped>
.bg-white {
  background-color: white;
}
</style>
